export default "__VITE_ASSET__km7KR1Ib__"